import { Link } from 'react-router-dom';
import { Loading } from './Loading';
import '../stylesheets/ArchiveJournals.css';
import { getPdfPageLink } from '../utils/pdfUtils';

export function ArchiveJournals({ journals, loading, currentJournal, setCurrentJournal }) {
    function onMouseEnterJournal(event, disabled) {
        if (disabled) {
            const result = journals.filter(elem => elem.title === event.target.innerText)[0];
            setCurrentJournal(result);
        }
    }

    return (
        <div className='ArchiveJournals'>
            <div className='months'>
                {
                    journals.map(elem => <div key={elem._id}>
                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                onMouseEnterJournal(e, elem.disabled);
                            }}
                            className={elem.disabled ? 'active' : ''}
                            onMouseEnter={(e) => onMouseEnterJournal(e, elem.disabled)}
                            style={{ cursor: elem.disabled ? 'pointer' : 'context-menu' }}
                        >
                            {elem.title}
                        </Link>
                    </div>)
                }
            </div>

            {
                loading ? <Loading /> : <div className='content'>
                    <h2 className='heading'>
                        Բովանդակություն - {currentJournal.title} ({currentJournal.year})
                    </h2>

                    {
                        currentJournal.content?.map((elem, index) => (
                            <a className='row' href={getPdfPageLink(currentJournal.url, elem.page)} target='_blank' rel='noreferrer' key={index}>
                                <p className='sub_content'>{elem.text}</p>
                                <p className='page'>{elem.page}</p>
                            </a>)
                        )
                    }
                </div>
            }
        </div>
    )
}